import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'

// Any signed-in member, whatever their role. Anonymous visitors are refused.
const SignedInRoute = () => {
    const { isAnonymous, loading } = useAuth()

    if (loading) {
        return null
    }

    if (isAnonymous) {
        return <Navigate to="/access-denied" />
    }

    return <Outlet />
}

export default SignedInRoute
